import comp from "./GenericCardView";
export default comp;
